import { render, staticRenderFns } from "./login-CA.vue?vue&type=template&id=40778372&scoped=true&"
import script from "./login-CA.vue?vue&type=script&lang=js&"
export * from "./login-CA.vue?vue&type=script&lang=js&"
import style0 from "./login-CA.vue?vue&type=style&index=0&id=40778372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40778372",
  null
  
)

export default component.exports